import React, { useEffect, useState } from 'react';
import { FaTrashAlt, FaPen } from 'react-icons/fa';

const MyReview = ({ review, handleDeleteRev, handleUpdateRev }) => {
    const [food, setFood] = useState([]);
    const [updatedReview, setUpdatedReview] = useState({ review: review.review });
    useEffect(() => {
        fetch(`https://salma-kitchen-server.vercel.app/food/${review.foodId}`)
            .then(res => res.json())
            .then(data => setFood(data));


    }, [review.foodId]);

    const handleOnBlur = (event) => {
        setUpdatedReview({ review: event.target.value });
    }

    return (
        <tr>
            <td className='hidden'></td>
            <td>
                <div>
                    <div className="flex items-center space-x-3">
                        <div className="avatar">
                            <div className="mask mask-squircle w-12 h-12">
                                <img src={food.image} alt="FoodImage" />
                            </div>
                        </div>
                        <div>
                            <div className="font-bold">{food.name}</div>
                            <div className="text-sm opacity-50">Price: {food.price}</div>
                        </div>
                    </div>
                </div>
            </td>
            <td>
                {review.name ? review.name : 'username'}
            </td>
            <td className='whitespace-normal'>{review.review}</td>
            <td>
                <input type="checkbox" id={review._id} className="modal-toggle" />
                <div className="modal modal-bottom sm:modal-middle">
                    <div className="modal-box">
                        <div className="form-control">
                            <label className="label">
                                <button><span className="label-text text-2xl">Update Your Review</span></button>
                            </label>
                            <textarea onBlur={handleOnBlur} defaultValue={review.review} name='review' className="textarea textarea-bordered h-24" placeholder="Type your feedback here"></textarea>
                        </div>
                        <div className="modal-action">
                            <button onClick={() => { handleUpdateRev(review._id, updatedReview) }}><label htmlFor={review._id} className="btn">Update</label></button>
                        </div>
                    </div>
                </div>
                <button><label htmlFor={review._id} className="btn"> <FaPen></FaPen> </label></button>
                <button onClick={() => handleDeleteRev(review._id)} className="btn mx-2"> <FaTrashAlt></FaTrashAlt> </button>
            </td>
        </tr>
    );
};

export default MyReview;